<template>
  <div class="whole">
    <div class="whole-box">
      <div class="whole-content">
        <div class="whole-content-left">
          <div class="whole-content-one">档案管理 \ 进度把控 \公示查询 \ 航拍地图 \ 房源管理</div>
          <div class="whole-content-two">高效·协作·全流程</div>
          <div class="whole-content-three">全程端</div>
          <div class="whole-content-four" style=" margin-top: 30px;">利用科技手段，开发适用于各地不同征收业务的覆盖征收全流程</div>
          <div class="whole-content-four">的管理系统，供政府征收部门、第三方征收服务公司使用，让原</div>
          <div class="whole-content-four">来无序的工作变得阳光、规范、有序，提升征收项目管理品质</div>
          <div class="whole-btn" @click="toLogin()">点击登录</div>
        </div>
        <div class="whole-content-right">
          <img src="../assets/img/quancheng_011.png" />
        </div>
      </div>
    </div>
    <div class="whole-content-box">
      <div class="whole-one">
        <div class="whole-one-left" id="wrapper-text">
          <div class="text-one">电子档案管理</div>
          <div
            class="text-two"
          >档案管理包括项目档案、分户档案盒项目归档，支持跨项目、多条件自定义筛选条件查询。所有数据信息、附件文件支持通过高拍仪直接上传至系统，形成一户一档，档案云储存，随时可调可查，支持项目所有附件打包下载。</div>
        </div>
        <div class="whole-one-right" id="wrapper-img">
          <img src="../assets/img/quancheng_02.png" />
        </div>
      </div>
      <div class="whole-two">
        <div class="whole-two-left" id="wrapper-img1">
          <img src="../assets/img/qcd.png" />
        </div>
        <div class="whole-two-right" id="wrapper-text1">
          <div class="text-one">项目进度把控</div>
          <div class="text-two">为政府征收办领导、机构项目负责人提供督导工具，可通过网页端首页的图表展示或微信领导端实时把控项目进度，查看各类重要数据的统计。</div>
        </div>
      </div>
      <div class="whole-three">
        <div class="whole-three-left" id="wrapper-text2">
          <div class="text-one">公示查询</div>
          <div class="text-two">支持微信公众号、电脑网页、公示触摸一体机、指挥部大屏幕等方式查询，为被征收户提供便捷的征收信息查询工具。保证征收过程的阳光、公平、公正。</div>
          <div class="whole-into-btn" @click="pushToNewPage()">点击进入>></div>
        </div>
        <div class="whole-three-right" id="wrapper-img2">
          <img src="../assets/img/quancheng_04.png" />
        </div>
      </div>
      <div class="whole-two">
        <div class="whole-two-left" id="wrapper-img3">
          <img src="../assets/img/quancheng_05.png" />
        </div>
        <div class="whole-two-right" id="wrapper-text3">
          <div class="text-one">航拍地图</div>
          <div class="text-two">提供航拍服务并将地图导入系统，地图动态反应征收情况，实时展示被征收户各类数据，把控进度，风险预警，实现可视化图上征收。</div>
        </div>
      </div>
      <div class="whole-three">
        <div class="whole-three-left" id="wrapper-text4">
          <div class="text-one">房源管理</div>
          <div
            class="text-two"
          >综合管理安置房源，包括：房源登记、结算、领用、销控等管理功能，支持Excel批量导入房源信息，可支持使用外接硬件设备：身份证识别器、二维码扫码枪等设备进行快速选房。</div>
        </div>
        <div class="whole-three-right" id="wrapper-img4">
          <img src="../assets/img/quancheng_06.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight whole-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft whole-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft whole-two-left'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight whole-two-right'
    );
    var x2 = document.getElementById('wrapper-img2');
    x2.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight whole-three-right'
    );
    var y2 = document.getElementById('wrapper-text2');
    y2.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft whole-three-left'
    );
    var x3 = document.getElementById('wrapper-img3');
    x3.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft whole-two-left'
    );
    var y3 = document.getElementById('wrapper-text3');
    y3.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight whole-two-right'
    );
    var x4 = document.getElementById('wrapper-img4');
    x4.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight whole-three-right'
    );
    var y4 = document.getElementById('wrapper-text4');
    y4.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft whole-three-left'
    );
  },
  methods: {
    toLogin() {
      window.open('https://ep.yunzhengshou.com');
    },
    pushToNewPage() {
      window.open('https://eh.yunzhengshou.com');
    }
  }
};
</script>
<style>
.whole {
  width: 100%;
}
.whole-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.whole-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.whole-content-left {
  margin-top: 70px;
  margin-left: 30px;
  width: 50%;
}
.whole-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.whole-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.whole-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.whole-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.whole-btn {
  width: 110px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  text-align: center;
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  cursor: pointer;
  margin-top: 42px;
}
.whole-btn:hover {
  color: rgb(41, 146, 151);
}
.whole-into-btn {
  width: 120px;
  height: 30px;
  /* background-color: rgba(255, 255, 255, 1); */
  /* border-radius: 10px; */
  /* border: 1px solid rgba(0, 189, 183, 1); */
  text-align: left;
  line-height: 20px;
  color: #999999;
  cursor: pointer;
  margin-top: 20px;
}
.whole-into-btn:hover {
  color: rgb(41, 146, 151);
}
.whole-content-right {
  /* margin-left: 135px; */
  width: 50%;
}
.whole-content-right img {
  width: 100%;
}
.whole-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.whole-one,
.whole-two,
.whole-three {
  display: flex;
  padding: 50px 64px;
}
.text-one {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 48px;
  color: #495362;
}
.text-two {
  margin-top: 10px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.whole-one-left {
  width: 50%;
}
.whole-one-right {
  width: 50%;
}
.whole-three-left {
  width: 50%;
  padding-right: 60px;
}
.whole-one-right img {
  margin-left: 50px;
}
.whole-two-left,
.whole-two-right {
  width: 50%;
}
.whole-two-right {
  margin-left: 152px;
}
.whole-two-left img {
  width: 100%;
}
.whole-three-right img {
  width: 100%;
}
.whole-three-right {
  width: 50%;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .whole-content,
  .whole-content-box {
    width: 1200px !important;
  }
  .whole-content-two {
    font-size: 36px !important;
  }
  .whole-content-four {
    font-size: 16px !important;
  }
  .text-one {
    font-size: 36px !important;
  }
  /* .whole-one-right img {
    width: 600px !important;
    margin-left: 50px !important;
  } */
  .text-two {
    font-size: 20px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/whole-process.vue